import { translate } from '../../util/translate'

export const headers = [
  {
    text: translate['divergence.table.headers.code'],
    value: 'appointment_code',
    width: 90,
  },
  {
    text: translate['divergence.table.headers.type'],
    value: 'types',
    width: 190,
  },
  {
    text: translate['divergence.table.headers.realty'],
    value: 'realty_code',
    width: 380,
  },
  {
    text: translate['divergence.table.headers.host'],
    value: 'host_name',
    width: 220,
  },
  {
    text: translate['divergence.table.headers.realEstate'],
    value: 'real_estate_name',
    width: 200,
  },
  {
    text: translate['divergence.table.headers.createdAt'],
    value: 'oldest_created_at',
    width: 150,
  },
  {
    text: translate['divergence.table.headers.status'],
    value: 'statuses',
    width: 130,
  },
  {
    text: translate['divergence.table.headers.items'],
    value: 'item_count',
    align: 'center',
    width: 80,
  },
  {
    text: translate['divergence.table.headers.estimated'],
    value: 'estimated_host_delta_sum',
    align: 'right',
    width: 150,
  },
  { value: 'actions', align: 'end', width: 65 },
]
